const OfferTypeForSale = 'for-sale';
const OfferTypeForRent = 'for-rent';
const OfferTypeForHoliday = 'for-holidays';
const OfferTypeAll = 'all';

type OfferType = 'for-sale' | 'for-rent' | 'for-holidays' | 'all';

export {
    OfferType,
    OfferTypeAll,
    OfferTypeForSale,
    OfferTypeForRent,
    OfferTypeForHoliday,
};
